import '../../styles/app.css'
import { useState, useRef } from 'react'
import { validateMessage } from '../../Utils/verificatorMessages'
import { ReactComponent as ButtonIcon } from '../../img/sendButtonIcon.svg'

const TextArea = ({ onSend }) => {
  const textareaRef = useRef(null)
  const [textareaRows, setTextareaRows] = useState(1)

  const handleSendClick = () => {
    const userMessage = textareaRef.current.value.trim()
    const validator = () => {
      if (!validateMessage(userMessage)) return
      onSend(userMessage)
      textareaRef.current.value = ""
      setTextareaRows(1)
    }

    validator()
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSendClick()
    }
  }

  const handleInput = (event) => {
    const textareaLineHeight = 24
    const maxRows = 5
    const currentRows = Math.floor(event.target.scrollHeight / textareaLineHeight)

    setTextareaRows(currentRows < maxRows ? currentRows : maxRows)
  }

  return (
    <div className="textarea-container">
      <textarea
        ref={textareaRef}
        className="textarea"
        placeholder="Digite a sua mensagem..."
        rows={textareaRows}
        onKeyDown={handleKeyDown}
        onInput={handleInput}
        style={{ overflowY: textareaRows === 5 ? 'auto' : 'hidden' }}
        autoFocus
      />
      <button className="chat-Button" onClick={handleSendClick}>
        <ButtonIcon className="buttonIcon" />
      </button>
    </div>
  )
}

export default TextArea